import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

type ObjectWithProps<T> = Record<string, T>;

// 객체에서 원하는 key를 가진 객체만 추출
export const pickByKeys = <T>(
  obj: ObjectWithProps<T> | undefined,
  ...propNames: string[]
): ObjectWithProps<T> => {
  if (!obj || !propNames) {
    return {};
  }

  return Object.keys(obj).reduce((acc, key) => {
    if (propNames.includes(key)) {
      acc[key] = obj[key];
    }

    return acc;
  }, {} as ObjectWithProps<T>);
};

// 빈 객체 생성
export const createEmptyObject = (obj: any): any => {
  const emptyObject: any = {};
  for (const key in obj) {
    // 만약 값이 객체나 배열이라면 재귀
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      emptyObject[key] = createEmptyObject(obj[key]);
    } else {
      emptyObject[key] = undefined;
    }
  }
  return emptyObject;
};

export const createDebouncer = (delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  return function (callback: () => void) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      callback();
      timeoutId = null;
    }, delay);
  };
};
